export enum StoreFilterDataDispatchTypes {
    STORE_FILTER_INFORMATION_INVOKE = "STORE_FILTER_INFORMATION_INVOKE",
    STORE_FILTER_INFORMATION_SUCCESS = "STORE_FILTER_INFORMATION_SUCCESS",
  }